import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, Password, RequiredValidator, SwitchGroup, SwitchGroupValidator } from '../../Components/Form';
import { useUser } from '../../Data/Users';

const ResetAccount = () => {
    const {resetAccount} = useUser();

    const handleSubmit = async (data) => {
        await resetAccount(data);
        window.location.replace('/more');
    }

    return <>
        <TopBar left="BackBtn" title="Reset Account" />

        <Page>

            <div className="prose prose-slate prose-sm mb-5">
                <p>
                    If you've been trying getSoapy and want a fresh start, you can archive all your customers and start again. Archived customers are still available and can be restored at any time.
                </p>

            </div>

            <Form onSubmit={handleSubmit}>
                <SwitchGroup name="toggles"
                    label="Confirm"
                    switches={[
                        {label: 'Archive all customers', name: 'archiveCustomers'},
                    ]}
                    validators={[SwitchGroupValidator(['archiveCustomers'], 'Please confirm all options')]}
                />
                <Password name="password" label="Confirm your password" validators={[RequiredValidator]} />
                <Actions submit={{label: 'Reset account'}} />
            </Form>

        </Page>
    </>
}

export default ResetAccount;
